import React, { useEffect, useState } from 'react';
import clsx from "clsx";
import { useIntl } from "react-intl";
import ReactQuill from 'react-quill';
import { useNavigate, useParams } from "react-router-dom";
import { CheckOutlined } from "@ant-design/icons";
import { Divider, Form, Spin, Avatar, Collapse, Steps } from "antd";
import styled from "styled-components";
import * as constants from "../../constants";
import { getContent, toggleSpinner, editContent, setContent, getOpportunity, getProgramById, getIndicatorAnswers } from "../../redux/actions";
import StyledText from "../../components/StyledText";
import Button from "../../components/Button";
import { getLocalStorageItem } from "../../utils/utilities";
import {
    toggleSpinnerSelector,
    opportunityDataSelector,
    savedContentListSelector,
    savedContentDataSelector,
    programDataSelector,
    indicatorDataSelector
} from "../../redux/selectors";
import {
    useAppDispatch,
    useAppSelector
} from "../../redux/store";
import goal1 from "../../assets/goal1.png";
import goal2 from "../../assets/goal2.png";
import goal3 from "../../assets/goal3.png";
import goal4 from "../../assets/goal4.png";
import goal5 from "../../assets/goal5.png";
import goal6 from "../../assets/goal6.png";
import goal7 from "../../assets/goal7.png";
import goal8 from "../../assets/goal8.png";
import goal9 from "../../assets/goal9.png";
import goal10 from "../../assets/goal10.png";
import goal11 from "../../assets/goal11.png";
import goal12 from "../../assets/goal12.png";
import goal13 from "../../assets/goal13.png";
import goal14 from "../../assets/goal14.png";
import goal15 from "../../assets/goal15.png";
import goal16 from "../../assets/goal16.png";
import goal17 from "../../assets/goal17.png";
import goalInverted1 from "../../assets/goalInverted1.png";
import goalInverted2 from "../../assets/goalInverted2.png";
import goalInverted3 from "../../assets/goalInverted3.png";
import goalInverted4 from "../../assets/goalInverted4.png";
import goalInverted5 from "../../assets/goalInverted5.png";
import goalInverted6 from "../../assets/goalInverted6.png";
import goalInverted7 from "../../assets/goalInverted7.png";
import goalInverted8 from "../../assets/goalInverted8.png";
import goalInverted9 from "../../assets/goalInverted9.png";
import goalInverted10 from "../../assets/goalInverted10.png";
import goalInverted11 from "../../assets/goalInverted11.png";
import goalInverted12 from "../../assets/goalInverted12.png";
import goalInverted13 from "../../assets/goalInverted13.png";
import goalInverted14 from "../../assets/goalInverted14.png";
import goalInverted15 from "../../assets/goalInverted15.png";
import goalInverted16 from "../../assets/goalInverted16.png";
import goalInverted17 from "../../assets/goalInverted17.png";
import 'react-quill/dist/quill.snow.css';

const goalsData = [
    { key: 1, image: goalInverted1, selected: goal1 },
    { key: 2, image: goalInverted2, selected: goal2 },
    { key: 3, image: goalInverted3, selected: goal3 },
    { key: 4, image: goalInverted4, selected: goal4 },
    { key: 5, image: goalInverted5, selected: goal5 },
    { key: 6, image: goalInverted6, selected: goal6 },
    { key: 7, image: goalInverted7, selected: goal7 },
    { key: 8, image: goalInverted8, selected: goal8 },
    { key: 9, image: goalInverted9, selected: goal9 },
    { key: 10, image: goalInverted10, selected: goal10 },
    { key: 11, image: goalInverted11, selected: goal11 },
    { key: 12, image: goalInverted12, selected: goal12 },
    { key: 13, image: goalInverted13, selected: goal13 },
    { key: 14, image: goalInverted14, selected: goal14 },
    { key: 15, image: goalInverted15, selected: goal15 },
    { key: 16, image: goalInverted16, selected: goal16 },
    { key: 17, image: goalInverted17, selected: goal17 }
];

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 12 },
};

const getUniqueSortedOutcomeUNSDG = (objectives, isProgramCustom) => {
    const outcomes = objectives?.flatMap(objective =>
        isProgramCustom ?
            objective?.objectivesOutcome?.flatMap(outcome => outcome?.outcomeUNSDG) :
            objective?.objectiveUNSDG
    ) || [];

    const uniqueSortedOutcomes = Array.from(new Set(outcomes)).sort((a, b) => a - b);

    return uniqueSortedOutcomes.map(el => {
        const selectedOutcomes = goalsData.find(gl => gl.key === el);
        return {
            key: el,
            image: selectedOutcomes?.image,
            selected: selectedOutcomes?.selected,
        };
    });
};

const CharityInterimCreateReport = ({ className }) => {
    const baseClassName = clsx("charityInterimCreateReport", className);
    const intl = useIntl();
    const [formData, setFormData] = useState({});
    const [expandAll, setExpandAll] = useState(false);
    const [selectedName, setSelectedName] = useState('');
    const [selectedUnsdgs, setSelectedUnsdgs] = useState([]);
    const [savedClicked, setSavedClicked] = useState(false);
    const [goalofCompanyProgramme, setGoalofCompanyProgramme] = useState('');
    const [quillError, setQuillError] = useState(false);
    const opportunityData = useAppSelector(opportunityDataSelector) || {};
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const indicators = useAppSelector(indicatorDataSelector) || {};
    const showSpinner = useAppSelector(toggleSpinnerSelector);
    const { ID } = useParams();
    const {
        ID: contentId,
        goalofCompanyProgramme: savedGoalofCompanyProgramme,
    } = useAppSelector(savedContentDataSelector) || {};
    const programData = useAppSelector(programDataSelector);
    const { opportunityID } = JSON.parse(getLocalStorageItem('contentData') || '{}');
    const { outcomeMethod } = programData || {};
    const { opportunity: { programID, impactApproach: { objectives } = {} } = {} } = opportunityData || {};
    const { message } = useAppSelector(savedContentListSelector) || {};
    const isProgramCustom = outcomeMethod === "Programme Custom";
    const maxChars = 500;

    const goals = getUniqueSortedOutcomeUNSDG(objectives);
    
    useEffect(() => {
        if (contentId) {
            const data = {
                ...(savedGoalofCompanyProgramme && { goalofCompanyProgramme: savedGoalofCompanyProgramme }),
            };
            form.setFieldsValue(data);
            setFormData(data);
            setGoalofCompanyProgramme(savedGoalofCompanyProgramme || '');
        }
    }, [contentId, savedGoalofCompanyProgramme, form]);

    useEffect(() => {
        if (message && !savedClicked) {
            dispatch(setContent(''));
            dispatch(toggleSpinner(false));
            if (Array.isArray(indicators) && indicators?.length > 0) {
                navigate(`/impact-maker/content/final/indicators/${ID}`);
            } else {
                navigate(`/impact-maker/content/final/case-studies/${ID}`);
            }
        } else if (message && savedClicked) {
            dispatch(setContent(''));
            dispatch(toggleSpinner(false));
            navigate(`/impact-maker/content`);
        }
    }, [message, savedClicked, dispatch, navigate, ID, indicators]);

    useEffect(() => {
        if (opportunityID) {
            document?.documentElement?.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            dispatch(getContent({ contentID: ID }));
            dispatch(getOpportunity(opportunityID));
            dispatch(getIndicatorAnswers({
                programID,
                opportunityID: opportunityID
            }));
        }
    }, [opportunityID, ID, dispatch, programID]);

    useEffect(() => {
        if (programID) {
            dispatch(getProgramById(programID));
        }
    }, [programID, dispatch]);

    const onFinishFailed = (errorInfo) => {
        console.log("Validation Failed:", errorInfo);
        const hasQuillError = errorInfo.errorFields.some(
            (field) => field.name[0] === 'goalofCompanyProgramme'
        );
        setQuillError(hasQuillError);
    };

    const handleQuillChange = (content, delta, source, editor) => {
        const plainText = editor.getText().trim();
        const charCount = plainText.length;
        if (charCount <= maxChars) {
            setGoalofCompanyProgramme(content);
            form.setFieldsValue({ goalofCompanyProgramme: plainText.length > 0 ? content : '' });
            form.validateFields(['goalofCompanyProgramme']).then(() => {
                setQuillError(false);
            }).catch(() => {
                setQuillError(true);
            });
        }
    };

    const handleProceed = () => {
        form.validateFields().then(values => {
            if (formData?.beneficiariesChanged && formData?.beneficiariesNumberChange && formData?.environmentMeasuresChange) return;
            const data = {
                contentId: ID,
                goalofCompanyProgramme: formData?.goalofCompanyProgramme,
                action: "Draft"
            };
            dispatch(editContent(data));
            dispatch(toggleSpinner(true));
            setQuillError(false);
        }).catch(errorInfo => {
            console.log('Validation Failed:', errorInfo);
            const hasQuillError = errorInfo.errorFields.some(
                (field) => field.name[0] === 'goalofCompanyProgramme'
            );
            setQuillError(hasQuillError);
        });
    };

    const handleSaveAndExit = () => {
        setSavedClicked(true);
        form.validateFields().then(() => {
            form.submit();
            setQuillError(false);
        }).catch(errorInfo => {
            console.log('Validation Failed:', errorInfo);
            const hasQuillError = errorInfo.errorFields.some(
                (field) => field.name[0] === 'goalofCompanyProgramme'
            );
            setQuillError(hasQuillError);
        });
    };

    const handlePrevious = () => {
        navigate(`/impact-maker/content/final/beneficiaries/${ID}`);
    };

    const onFormChange = (_, allValues) => {
        setFormData(allValues);
    };

    const extractAndGroupObjectivesOutcome = data => {
        return data?.map(({ name: title, objectivesOutcome, objectiveUNSDG }, index) => ({
            key: index,
            label: <StyledText as="p" variant="B3d">{title}</StyledText>,
            children: objectivesOutcome?.length > 0 && objectivesOutcome?.map(({ name, outcomeDescription, outcomeApproach, outcomeUNSDG }) => {
                return (
                    <button
                        key={outcomeDescription}
                        type="button"
                        className={`collapseChildContainer ${selectedName === name ? 'selectedName' : ''}`}
                        onClick={() => {
                            setSelectedUnsdgs([
                                ...(objectiveUNSDG ?? []),
                                ...(outcomeUNSDG ?? [])
                            ]);
                            setSelectedName(name);
                        }}
                    >
                        <StyledText as="p" variant="B3d">{name}</StyledText>
                        <StyledText as="p" variant="B3">{outcomeApproach || outcomeDescription}</StyledText>
                    </button>
                );
            })
        }));
    };

    const impactStrategyOutcomes = extractAndGroupObjectivesOutcome(objectives);

    return (
        <div className={baseClassName}>
            {showSpinner && (
                <div className="overlay">
                    <Spin className="spinner" size="large" spinning={showSpinner} />
                </div>
            )}
            <Steps
                current={1}
                items={[
                    {
                        title: <StyledText as="p" variant="H3">{intl.formatMessage({ id: "step_1" })}</StyledText>,
                        description: <StyledText as="p" variant="B3" className='mainTitle'>{intl.formatMessage({ id: "inputs_n_outputs" })}</StyledText>,
                    },
                    {
                        title: <StyledText as="p" variant="H3">{intl.formatMessage({ id: "step_2" })}</StyledText>,
                        description: <StyledText as="p" variant="B3c" className='mainTitle'>{intl.formatMessage({ id: "objectives_n_outcomes" })}</StyledText>,
                    },
                    {
                        title: <StyledText as="p" variant="H3">{intl.formatMessage({ id: "step_3" })}</StyledText>,
                        description: <StyledText as="p" variant="B3" className='mainTitle'>{intl.formatMessage({ id: "case_studies" })}</StyledText>,
                    },
                    {
                        title: <StyledText as="p" variant="H3">{intl.formatMessage({ id: "step_4" })}</StyledText>,
                        description: <StyledText as="p" variant="B3" className='mainTitle'>{intl.formatMessage({ id: "next_steps" })}</StyledText>,
                    },
                    {
                        title: <StyledText as="p" variant="H3">{intl.formatMessage({ id: "step_5" })}</StyledText>,
                        description: <StyledText as="p" variant="B3" className='mainTitle'>{intl.formatMessage({ id: "preview_n_submit" })}</StyledText>,
                    },
                ]}
            />
            <div className='contentContainer'>
                <div>
                    <StyledText as="p" variant="H1" className='mainTitle'>{intl.formatMessage({ id: "objectives_n_outcomes" })}</StyledText>
                    <Form
                        {...formItemLayout}
                        labelAlign="left"
                        onFinish={handleProceed}
                        onFinishFailed={onFinishFailed}
                        form={form}
                        className="formContainer"
                        scrollToFirstError
                        onValuesChange={onFormChange}
                    >
                        <div className="mainContentContainer">
                            <div className="contentContainer">
                                <StyledText as="p" variant="B3">{intl.formatMessage({ id: "below_are_the_objectives_and_outcomes_you_shared_in_your_application" })}</StyledText>
                                {impactStrategyOutcomes?.length > 0 && (
                                    <div className="subContainer">
                                        <StyledText as="p" variant="H2">{intl.formatMessage({ id: "impact_alignment" })}</StyledText>
                                        {isProgramCustom && (
                                            <button className="expandAll" onClick={() => setExpandAll(prev => !prev)}>
                                                {intl.formatMessage({ id: "expand_all" })}
                                            </button>
                                        )}
                                        <div className="unsdgPartitionContainer">
                                            <div className="unsdgsContainer">
                                                <button
                                                    className="showAllGoals"
                                                    onClick={() => { setSelectedUnsdgs([]); setSelectedName(''); }}
                                                >
                                                    <div><CheckOutlined /></div>
                                                    <StyledText as="p" variant="B3">{intl.formatMessage({ id: "show_all_goals" })}</StyledText>
                                                </button>
                                                {goals.map((el) => (
                                                    <Avatar
                                                        key={el.image}
                                                        src={selectedUnsdgs?.includes(el.key) ? el.selected : el.image}
                                                        shape="square"
                                                        className="unsdgs"
                                                    />
                                                ))}
                                            </div>
                                            <div className="collapseContainer">
                                                <Collapse
                                                    items={impactStrategyOutcomes}
                                                    activeKey={expandAll ? impactStrategyOutcomes.map(({ key }) => key) : undefined}
                                                    expandIconPosition="end"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <StyledText as="p" variant="B3d">{intl.formatMessage({ id: "were_you_successful_in_achieving_your_objectives_and_outcomes" })}</StyledText>
                                <Form.Item
                                    name="goalofCompanyProgramme"
                                    rules={[
                                        {
                                            validator: (_, value) => {
                                                const text = value && typeof value === 'string' ? value.replace(/<[^>]+>/g, '').trim() : '';
                                                if (text.length > 0) {
                                                    setQuillError(false);
                                                    return Promise.resolve();
                                                }
                                                setQuillError(true);
                                                return Promise.reject(new Error(intl.formatMessage({ id: "please_enter" })));
                                            }
                                        }
                                    ]}
                                >
                                    <ReactQuill
                                        theme="snow"
                                        value={goalofCompanyProgramme}
                                        onChange={handleQuillChange}
                                        placeholder={intl.formatMessage({ id: "enter_description" })}
                                        modules={{
                                            toolbar: [
                                                ['bold', 'italic', 'underline'],
                                                ['link'],
                                                [{ list: 'ordered' }, { list: 'bullet' }],
                                                ['clean'],
                                            ],
                                        }}
                                        className={quillError ? 'quill-error' : ''}
                                    />
                                </Form.Item>
                                <div className='buttonContainer'>
                                    <Divider />
                                    <div className='buttonContentContainer'>
                                        <div className='nextAndPreviousContainer'>
                                            <Button variant="secondary" type="button" onClick={handlePrevious}>
                                                {intl.formatMessage({ id: "previous" })}
                                            </Button>
                                            <Button variant="primary" htmlType="submit">
                                                {intl.formatMessage({ id: "next" })}
                                            </Button>
                                        </div>
                                        <div className="saveAndExitButton">
                                            <Button variant="secondary" htmlType="button" onClick={handleSaveAndExit}>
                                                {intl.formatMessage({ id: "save_n_exit" })}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="buttonContainer">
                                <Divider />
                                <div className="buttonContentContainer">
                                    <div className="nextAndPreviousContainer">
                                        <Button variant="secondary" type="button" onClick={() => handlePrevious()}>
                                            {intl.formatMessage({ id: "previous" })}
                                        </Button>
                                        <Button variant="primary" htmlType="submit">
                                            {intl.formatMessage({ id: "next" })}
                                        </Button>
                                    </div>
                                    <div className="saveAndExitButton">
                                        <Button variant="secondary" htmlType="button" onClick={() => handleSaveAndExit()}>
                                            {intl.formatMessage({ id: "save_n_exit" })}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
};

const StyledCharityInterimCreateReport = styled(CharityInterimCreateReport)`
  &.charityInterimCreateReport {
    background: white;
    display: flex;
    flex-direction: column;
    padding: 20px;
    justify-content: space-between;
    margin-top: 50px;

    .inputElement .ant-form-item-control-input {
        width: 200px;
    }

    .whiteSupportContainer {
        background: white;
        box-shadow: 0px 3px 16px #0000000d;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
        width: 35vw;
        &.volunteeringContainer {
            box-shadow: 0px 3px 16px #0000000d;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            gap: 16px;
        }
    }

    .smallInput {
        width: 500px;
    }

    .collapseChildContainer {
        border: 1px solid #d7dde1;
        padding: 12px 16px;
        margin-bottom: 6px;
        cursor: pointer;
        text-align: left;
        background: white;
        font-size: 14px;
        font-weight: ${constants.FONT_WEIGHT_SEMIBOLD};
        color: ${constants.COLOR_GREY_DARK};
        font-family: ${constants.POPPINS_FONT_FAMILY};
        &.selectedName {
            border: 1px solid #04ac9c;
            border-radius: 6px;
            background: #bcfbf5;
        }
    }

    .collapsible {
        display: flex;
        flex-direction: column;
        .collapseChildContainer {
            background: white;
            border: 0;
            border-bottom: 1px solid #d9d9d9;
            padding: 12px 16px;
            text-align: left;
            &.selectedName {
                border: 1px solid #04ac9c;
                background: #bcfbf5;
            }
            cursor: pointer;
        }
    }

    .subContainer {
        display: flex;
        flex-direction: column;
        gap: 10px;
        .descriptionContainer {
            max-width: 70ch;
            word-wrap: break-word;
            overflow-wrap: break-word;
            p, li {
                font-size: 14px;
                font-weight: 500;
                color: #242424;
                font-family: sans-serif;
                max-width: 70ch;
                word-wrap: break-word;
                overflow-wrap: break-word;
            }
        }
    }

    .ant-collapse-expand-icon {
        transform: rotate(90deg) translate(-5px);
        svg {
            fill: #313131 !important;
        }
    }

    .ant-collapse-item-active {
        .ant-collapse-expand-icon {
            transform: rotate(0deg) translate(-5px);
        }
    }

    .mainTitle {
        margin-bottom: 20px;
    }

    .contentContainer {
        display: flex;
        flex-direction: column;
        gap: 12px;
        min-height: 60vh;
        padding-bottom: 60px;
        .formContainer {
            display: flex;
            gap: 12px;
            flex-direction: column;
        }
    }

    .overlay {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1000;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.45);
    }

    .spinner {
        z-index: 2000;
        margin: auto;
        left: 50%;
        right: 50%;
        position: absolute;
        bottom: 50%;
    }

    .radioGroup {
        display: flex;
        flex-direction: column;
    }

    .formItemTextField {
        .ant-form-item-control-input {
            width: 34.5vw !important;
        }
    }

    .formItemTextFieldPart {
        .ant-form-item-control-input {
            width: 16vw !important;
        }
    }

    .helperText {
        color: #5271FF !important;
        font-weight: bold !important;
        margin-bottom: 0px !important;
    }

    .ant-form-item {
        margin-bottom: 10px;
    }

    .formItemInput {
        width: 300px;
    }

    .errorText {
        color: #ff4d4f;
    }

    .addButton {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .formContainer {
        display: flex;
        gap: 12px;
        flex-direction: column;
    }

    .optionsContainer {
        display: flex;
        align-items: center;
        gap: 30px;
        .for {
            margin-bottom: 10px;
        }
    }

    .buttonContainer {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        position: fixed;
        width: 100%;
        bottom: 0px;
        background: white;
        margin-left: -110px;
        .buttonContentContainer {
            display: flex;
            justify-content: center;
            width: 100%;
            position: relative;
            .saveAndExitButton {
                position: absolute;
                right: 0;
                margin-bottom: 15px;
            }
            .nextAndPreviousContainer {
                display: flex;
                gap: 20px;
                margin-bottom: 15px;
            }
        }
    }

    .unsdgPartitionContainer {
        display: flex;
        gap: 20px;
        background: white;
        padding: 30px;
        border-radius: 10px;
        .collapseContainer {
            width: 50%;
            button {
                width: 100%;
            }
        }
        .unsdgsContainer {
            display: flex;
            gap: 15px;
            width: 48%;
            flex-wrap: wrap;
            height: max-content;
            .showAllGoals {
                height: 100px;
                width: 100px;
                background: white;
                display: flex;
                flex-direction: column;
                padding: 15px;
                justify-content: center;
                align-items: center;
                text-align: center;
                border: 2px solid #00877a;
                border-radius: 6px;
                p, svg {
                    color: #00877a !important;
                }
            }
            .unsdgs {
                height: 100px;
                width: 100px;
            }
        }
    }

    .expandAll {
        color: #00877a;
        text-align: end;
        background: transparent;
        border: 0;
        cursor: pointer;
    }

    .ant-collapse {
        border: 0;
        border-bottom: 1px solid #D7DDE1;
        .ant-collapse-header {
            background: white !important;
        }
    }

    .ant-collapse-content-active {
        border-top: 0;
    }

    .quill-error {
        border: 1px solid red !important;
    }
}
`;

export default StyledCharityInterimCreateReport;